var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('avatar',{key:_vm.avatarUrl,attrs:{"username":_vm.team.name,"src":_vm.avatarUrl,"size":_vm.size,"lighten":100,"customStyle":{ 'background-size': 'contain', 'background-position': 'center' }}})}
var staticRenderFns = []

export { render, staticRenderFns }